import geoutils from './helper/geo'
import { ShapeMaker, TransformContext } from './types'

export type CircleOptions = {
  center: [number, number]
  stroke?: string
  fill?: string
  width?: number
  radius?: number
}

export default class CircleMaker implements ShapeMaker {
  center: [number, number]
  stroke: string | undefined
  fill: string | undefined
  width: number
  radius: number

  constructor(options: CircleOptions) {
    this.center = options.center
    this.stroke = options.stroke
    this.fill = options.fill
    this.width = Number.isFinite(options.width) ? Number(options.width) : 1
    this.radius = Number.isFinite(options.radius) ? Number(options.radius) : 3
  }

  /**
   * calculate the coordinates of the envelope / bounding box: (min_lon, min_lat, max_lon, max_lat)
   */
  extent() {
    return [this.center[0], this.center[1], this.center[0], this.center[1]] as [
      number,
      number,
      number,
      number
    ]
  }

  static toSVG(shape: CircleMaker, context: TransformContext) {
    const centerPx = [
      context.xToPx(geoutils.lonToX(shape.center[0], context.zoom)),
      context.yToPx(geoutils.latToY(shape.center[1], context.zoom)),
    ]

    return `<circle
    cx="${centerPx[0]}"
    cy="${centerPx[1]}"
    r="${shape.radius}"
    stroke="${shape.stroke || '#000000'}"
    stroke-width="${shape.width}"/>
    fill="${shape.fill || 'none'}"/>`
  }

  toSVG(context: TransformContext) {
    return CircleMaker.toSVG(this, context)
  }
}
